module.exports = __webpack_public_path__ + "static/media/Full_W_Article_Body.ee92517c.csv";